{
  "dismiss": "Скасувати"
}